export default "__VITE_ASSET__ad467596__"